import React, { useState, useEffect, Fragment } from 'react'
import { MyStore } from '../../../../services/Store'
import { Route, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Container, Message, Search, Dropdown, Sidebar, Menu, Icon, Grid, Image, Segment, Header, Button, Form, Table, Modal, Checkbox } from 'semantic-ui-react'

 

const OrgHomePage = (props) => {

    const [state, setState] = useState({
        showModal: false,
        imail: '',

    })


    return (


        <div class="main-content">
            <div class="ui grid stackable padded">
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile column"
                >
                    <div class="ui fluid card">
                        <div class="content">
                            <div class="ui right floated header red">
                                <i class="icon shopping cart"></i>
                            </div>
                            <div class="header">
                                <div class="ui red header">
                                    3958
          </div>
                            </div>
                            <div class="meta">
                                orders
        </div>
                            <div class="description">
                                Elliot requested permission to view your contact details
        </div>
                        </div>
                        <div class="extra content">
                            <div class="ui two buttons">
                                <div class="ui red button">More Info</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile column"
                >
                    <div class="ui fluid card">
                        <div class="content">
                            <div class="ui right floated header green">
                                <i class="icon clock"></i>
                            </div>
                            <div class="header">
                                <div class="ui header green">57.6%</div>
                            </div>
                            <div class="meta">
                                Time
        </div>
                            <div class="description">
                                Elliot requested permission to view your contact details
        </div>
                        </div>
                        <div class="extra content">
                            <div class="ui two buttons">
                                <div class="ui green button">More Info</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile column"
                >
                    <div class="ui fluid card">
                        <div class="content">
                            <div class="ui right floated header teal">
                                <i class="icon briefcase"></i>
                            </div>
                            <div class="header">
                                <div class="ui teal header">3112</div>
                            </div>
                            <div class="meta">
                                Saves
        </div>
                            <div class="description">
                                Elliot requested permission to view your contact details
        </div>
                        </div>
                        <div class="extra content">
                            <div class="ui two buttons">
                                <div class="ui teal button">More Info</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile column"
                >
                    <div class="ui fluid card">
                        <div class="content">
                            <div class="ui right floated header purple">
                                <i class="icon trophy"></i>
                            </div>
                            <div class="header">
                                <div class="ui purple header">9805</div>
                            </div>
                            <div class="meta">
                                Views
        </div>
                            <div class="description">
                                Elliot requested permission to view your contact details
        </div>
                        </div>
                        <div class="extra content">
                            <div class="ui two buttons">
                                <div class="ui purple button">More Info</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui grid stackable padded">
                <div class="column">
                    <table class="ui celled striped table">
                        <thead>
                            <tr>
                                <th colspan="3">
                                    Git Repository
          </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="collapsing">
                                    <i class="folder icon"></i> node_modules
          </td>
                                <td>Initial commit</td>
                                <td class="right aligned collapsing">10 hours ago</td>
                            </tr>
                            <tr>
                                <td><i class="folder icon"></i> test</td>
                                <td>Initial commit</td>
                                <td class="right aligned">10 hours ago</td>
                            </tr>
                            <tr>
                                <td><i class="folder icon"></i> build</td>
                                <td>Initial commit</td>
                                <td class="right aligned">10 hours ago</td>
                            </tr>
                            <tr>
                                <td><i class="file outline icon"></i> package.json</td>
                                <td>Initial commit</td>
                                <td class="right aligned">10 hours ago</td>
                            </tr>
                            <tr>
                                <td><i class="file outline icon"></i> Gruntfile.js</td>
                                <td>Initial commit</td>
                                <td class="right aligned">10 hours ago</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="ui grid stackable padded">
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile  center aligned column"
                >
                    <div class="ui teal statistic">
                        <div class="value">
                            5,550
      </div>
                        <div class="label">
                            Downloads
      </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile  center aligned column"
                >
                    <div class="ui purple statistic">
                        <div class="value">
                            50+
      </div>
                        <div class="label">
                            Developers
      </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile  center aligned column"
                >
                    <div class="ui green statistic">
                        <div class="value">
                            800+
      </div>
                        <div class="label">
                            Commits
      </div>
                    </div>
                </div>
                <div
                    class="four wide computer eight wide tablet sixteen wide mobile  center aligned column"
                >
                    <div class="ui purple statistic">
                        <div class="value">
                            1000+
      </div>
                        <div class="label">
                            Cups of Coffee
      </div>
                    </div>
                </div>
            </div>
        </div>
    )

}



export default OrgHomePage